module.exports = __webpack_public_path__ + "img/level-fail.5aa11559.png";